<template>
    <div style="height:100%;">
        <el-button type="primary" size="medium" @click="createReport">完成编辑，添加评标报告</el-button>
        <iframe :src="iframeUrl" frameborder="0" width="100%" style="height:calc(100% - 50px);"></iframe>
    </div>
</template>
<script>
export default {
    props:{
        
    },
    data(){
        return{
            fileKey:"",
            iframeUrl:"",
            loading:false,
        }
    },
    methods:{
        //查询是否完成编辑
        createReport(){
            var that = this;
            this.loading = this.$loading({
                lock: true,
                text: '评标报告生成中，请稍后。。。',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.iframeUrl = "";
            var interval = setInterval(() => {
                that.$ajax({
                    url:`${this.getGetters('bidUrl')}/bidding/kaibiao/createPbbgOnline/checkFinish.json`,
                    type:'get',
                    data:{
                        key:that.fileKey,
                    },
                    callback:function(data){
                        if(data == 'finished'){
                            clearInterval(interval);
                            that.addReport();
                        }
                    },
                    complete:function(data){
                        if(data.responseJSON.code == 'error'){
                            that.loading.close();
                            clearInterval(interval);
                        }
                    },
                })  
            }, 1000);
        },
        //添加/修改评标报告
        addReport(){
            var that = this;
            
            that.$ajax({
                url:`${this.getGetters('bidUrl')}/bidding/kaibiao/createPbbgOnline/createPbbg.json`,
                type:'post',
                data:{
                    key:that.fileKey,
                },
                callback:function(data){
                    that.loading.close();
                    that.goto({
                        path:"./list",
                        query:{
                            ...that.getQuery(),
                        }
                    })
                },
                complete:function(data){
                    if(data.responseJSON.code == 'error'){
                        that.loading.close();
                    }
                },
            })  
        },
    },
    mounted(){
        this.$alert('请仔细核对评标报告内容', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            
          }
        });
        this.fileKey = this.getQuery("templateFileKey");
        this.iframeUrl = this.getQuery("templateIframeUrl");
    }
}
</script>